export const projectsData = [
  {
    id: 1,
    title: "City-Light",
    date: "Octobre 2021",
    languages: ["HTML", "CSS", "JavaScript"],
    infos:
    "Projet réalisé sur le thème du tourisme urbain.",
    img: "./assets/img/nantes-pic.jpg",
    link: "https://rodolphebeloncle.github.io/city-light/",
  },
  {
    id: 2,
    title: "GreenBeens",
    date: "Novembre 2021",
    languages: ["HTML/CSS", "React.js"],
    infos:
      "Application web réalisée autour de 'l'api openfoodfact.Faciliter l'accès des consomateurs qui ont des allergies particulières.",
    img: "./assets/img/greenbeens.png",
    link: "https://ecstatic-khorana-51c89c.netlify.app",
  },
  {
    id: 3,
    title: "ShopWear",
    date: "Novembre 2021",
    languages: ["HTML/CSS", "React.js"],
    infos:
      "Réalisation d'un mini magasin de vêtement partie front-end",
    img: "./assets/img/shopwear.png",
    link: "https://determined-euler-ea63d7.netlify.app",
  },
  {
    id: 4,
    title: "React & Api",
    date: "Décembre 2021",
    languages: ["HTML/CSS", "React & Tailwind"],
    infos:
      "Api Game avec Context & Tailwind",
    img: "./assets/img/GameApi.png",
    link: "https://eloquent-mirzakhani-ff9d63.netlify.app",
  },
];
